import { render, staticRenderFns } from "./ChurnPredictionIcon.vue?vue&type=template&id=2006eec4&"
import script from "./ChurnPredictionIcon.vue?vue&type=script&lang=js&"
export * from "./ChurnPredictionIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports